module.exports = __webpack_public_path__ + "img/allergies.bfd1abac.svg";